import React, { createContext, useCallback, useContext, useState } from 'react';

interface AskQuickContextValue {
  isOpen: boolean;
  togglePanel: () => void;
  closePanel: () => void;
}

const AskQuickContext = createContext<AskQuickContextValue>({
  isOpen: false,
  togglePanel: () => {},
  closePanel: () => {}
});

export const AskQuickProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePanel = useCallback(() => setIsOpen((prev) => !prev), []);
  const closePanel = useCallback(() => setIsOpen(false), []);

  return <AskQuickContext.Provider value={{ isOpen, togglePanel, closePanel }}>{children}</AskQuickContext.Provider>;
};

export const useAskQuick = () => useContext(AskQuickContext);
